import React, { useState  , useEffect } from "react";
import "./../profile.css";
import AddEditAddress from "./AddEditAddress";
import { useDispatch, useSelector } from "react-redux";
import { profileAction } from "../../../redux/action";
import { getUser } from "../../../constant/utils";
import Loader from "react-loader-spinner";

const ManageAddress = () => {
  const USER = getUser();
  console.log("user data", USER);
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const addressData: any[] = useSelector((state: any) =>
    state.profile.addressList ? state.profile.addressList : []
  );
  const commonLoading: any = useSelector((state: any) =>
    state.common.loader ? state.common.loader : false
  );

    useEffect(() => {
    if (USER?.Id) {
      const payload = {
        UserData: {
          Id: USER.Id,
        },
      };

      console.log("Address List Payload:", payload);

      dispatch(profileAction.addressListAction(payload));
    }
  }, []);
  const handleOpen = (data: any) => {
    setEditData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setEditData({});
    setOpen(false);
  };
  const handleDelete = (data: any) => {
    if (window.confirm("Are you want to delete ?")) {
    } else {
    }
  };

  function getFullAddress(address: any) {
    let fAdd: any = address?.house_no ? address?.house_no : "";
    fAdd += address?.locality_name ? `, ${address?.locality_name}` : "";
    fAdd += address?.landmark ? `, ${address?.landmark}` : "";
    return fAdd;
  }

  const handleUpdate = (data: any) => {
    let userdatas = {
      UserData: { Id: USER?.Id },
    };
    if (editData?.id) {
      dispatch(
        profileAction.updateAddressAction(
          { ...data, AddressId: editData?.id, ...userdatas },
          () => onSuccessAddMember()
        )
      );
    } else {
      dispatch(
        profileAction.addAddressAction({ ...data, ...userdatas }, () =>
          onSuccessAddMember()
        )
      );
    }
  };
  function onSuccessAddMember() {
    setOpen(false);
    setEditData({});
    let userdatas = {
      UserData: { Id: USER?.Id },
    };

    const payload = {
      UserData : {
        Id : USER?.Id
      }
    }
    console.log("payload" , payload);
    dispatch(profileAction.addressListAction(payload));
  }
  return (
    <React.Fragment>
      <div className="tc_box">
        <div className="heading_box">
          <div className="row justify-content-between">
            <span className="col">Manage Addresses</span>
            <a
              href=""
              className="book--hexagon add_acc"
              onClick={(e: any) => {
                e.preventDefault();
                handleOpen({});
              }}
            >
              <span>
                <img
                  className="mr-2"
                  src="/assets/img/my-profile/plus.png"
                  aria-hidden="true"
                  width={16}
                  height={16}
                />
                Add New Address
              </span>
            </a>
          </div>
        </div>
        <div className="address_box_list">
          {commonLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader type="ThreeDots" color="#fff" height={100} width={100} />
            </div>
          ) : addressData?.length > 0 ? (
            <>
              {addressData?.map((ele: any, idx: any) => (
                <div className="address_box" key={idx}>
                  <div className="add_detail">
                    <img
                      src="assets/img/my-profile/profile-module4.png"
                      alt=""
                    />
                    <div>
                      <p>{getFullAddress(ele)}</p>
                      <p>
                        {ele?.city_name}, {ele?.state_name}
                      </p>
                      <p>Pincode : {ele?.pincode}</p>
                    </div>
                  </div>
                  <div className="d-flex flex-column  justify-content-between aling-items-end">
                    <div className="default_add">
                      {idx == 0 ? "Default Address" : ""}
                    </div>
                    <div className="text-right">
                      <img
                        src="assets/img/my-profile/edit.png"
                        alt=""
                        className="cursor-pointer scale_picon"
                        onClick={(e: any) => {
                          handleOpen(ele);
                        }}
                      />
                      {/* <img
                    src="assets/img/my-profile/delete.png"
                    alt=""
                    className="cursor-pointer scale_picon ml-3"
                    onClick={(e: any) => {
                      handleDelete(ele);
                    }}
                  /> */}
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="address_box">
              <p className="text-center w-100 font-weight-bold">
                No address found
              </p>
            </div>
          )}
        </div>
      </div>
      {open && (
        <AddEditAddress
          open={open}
          editData={editData}
          handleClose={handleClose}
          handleSubmit={handleUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default ManageAddress;
